export default "__VITE_PUBLIC_ASSET__ee9d7d1b__"